// elements/x-components.ts
import { html, svg } from "lit";
import { customElement } from "lit/decorators.js";
import { DesignSystem } from "./theming/design.js";
var templateResultCache = /* @__PURE__ */ new WeakMap();
var processChild = (child) => child?._$litType$ === 1 ? xComponents(child) : child;
var iterateChild = (children) => Array.isArray(children) ? children.map((c) => iterateChild(c)) : processChild(children);
var getChildren = (templateResult) => templateResult.values.map((value) => {
  if (value?._$litDirective$)
    value.values = value.values.map((v) => iterateChild(v));
  return iterateChild(value);
});
var xComponents = (templateResult) => {
  const templateResultCacheHit = templateResultCache.get(templateResult.strings);
  if (templateResultCacheHit)
    return { ...templateResultCacheHit, values: getChildren(templateResult) };
  const designSystemPrefix = DesignSystem.prefix;
  const strings = templateResult.strings;
  const replacedStrings = strings.map((str) => str.replace(/<([\/]{0,1})x-/g, `<$1${designSystemPrefix}-`));
  replacedStrings.raw = strings.raw.map((str) => str.replace(/<([\/]{0,1})x-/g, `<$1${designSystemPrefix}-`));
  const values = getChildren(templateResult);
  const finalTemplateResult = templateResult._$litType$ === 2 ? svg(replacedStrings, ...values) : html(replacedStrings, ...values);
  templateResultCache.set(templateResult.strings, finalTemplateResult);
  return finalTemplateResult;
};
var createComponentsFromChemistryBase = (...names) => {
  for (const name of names) {
    const baseName = name.replace(/^\w+-/, "");
    const existing = customElements.get(`x-${baseName}`);
    if (!existing)
      throw new Error(`${baseName} doesn't exist as x-* component yet. Maybe you need to import it?`);
    const newClass = class extends existing {
    };
    customElement(`${DesignSystem.prefix}-${baseName}`)(newClass);
  }
};
export {
  createComponentsFromChemistryBase,
  xComponents
};
